export default __webpack_public_path__ + "static/media/clientThree.5438d188.png";